import { InjectionToken } from '@angular/core';
import { ISkyResourceConfig } from './interface';

export const RESOURCE_CONFIG = new InjectionToken<ISkyResourceConfig>('sky.resource.config');
